import $ from 'jquery';
 import 'jquery-validation'; 
import 'jquery-validation-unobtrusive'; 
 
  

window.addEventListener('DOMContentLoaded', () => { 
    $('.button[type="submit"]').prop('disabled', true); 
    if (window.location.hash) {
        let hash = window.location.hash.substring(1);
        const element = document.getElementById(hash);
        if (element) { 
            element.click();
        }
    }

    var searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('type')) {
        const membershipType = searchParams.get('type');
        const membershipTypeSelector = document.querySelector('.js-membership-type');
 
        if (membershipTypeSelector) {
            membershipTypeSelector.value = membershipType;
            membershipTypeSelector.dispatchEvent(new Event('change'));
        }
        
    }
    if ($('.field-validation-error').length > 0) {
        
        document.getElementById('apply-now').click(); 
    }
    
      
    $('#IndividualForm').on('submit', function (e) {
        e.preventDefault();   
        var formElement = $(this)[0];
        var formData = new FormData(formElement);
        var selectedValue = $('#SelectedMembership').val(); 
        var actionVariable = '';
        switch (selectedValue) { 
            case 'FriendsOfArchitecture':
                actionVariable = 'Friend';
                break;
            default:
                actionVariable = selectedValue; 
                break;
        }
        var actionMethod = `Submit${actionVariable}Form`; 
        if (window.currentform.valid()){ 

               $('.field-validation-error')
            .removeClass('field-validation-error')
            .addClass('field-validation-valid')
            .text('');


            $.ajax({
                url: `/umbraco/surface/JoinForm/${actionMethod}`,
                type: 'POST',   
                data: formData ,
                processData: false,
                contentType: false, 
                success: function (response) {
                    $('#js-thank-you').show();
                    $('#individual-member-form').hide();
                    $('#IndividualForm').find('input[type=text], input[type=tel], input[type=email]').val('');
                    $('#IndividualForm').find('input[type=checkbox], input[type=radio]').prop('checked', false);
                    $('#IndividualForm').find('select').val(''); 
                    const targetId = $('#apply-now').attr('href');
                    const targetElement = $(targetId);
                    $('html, body').animate({
                        scrollTop: targetElement.offset().top
                    }, 800); 
                },   error: function (xhr) {
                if (xhr.responseJSON) {
                    const response = xhr.responseJSON;

                    if (response.message) {
                        alert(response.message);
                    }

                    if (response.errors) {
                        Object.keys(response.errors).forEach(function (key) {
                            const messages = response.errors[key];
                            const validationSpan = $(`[data-valmsg-for="${key}"]`);

                            if (validationSpan.length) {
                                validationSpan
                                    .removeClass('field-validation-valid')
                                    .addClass('field-validation-error')
                                    .text(messages[0]);
                            }
                        });
                    }
                } else {
                    alert('An unexpected error occurred.');
                }
            }
            });
        }
       
    });
});
